import { connect } from 'react-redux'
import ConciergeView from '../components/ConciergeView'
import { getPatients } from '../../../store/patients'
import { getSites } from '../../../store/sites'
import { getUsers } from '../../../store/user'
import { createAppointment, getNearbyAppointments } from '../../../store/appointments'

const mapDispatchToProps = {
  getPatients,
  getSites,
  createAppointment,
  getNearbyAppointments,
  getUsers
}

const mapStateToProps = (state) => {
    
  console.log(state)

  return {
    sites: state.sites.sites,
    patients: state.patients,
    ui: state.ui,
    appointment: state.appointment,
    users: state.user.users
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConciergeView)



// WEBPACK FOOTER //
// ./src/routes/Concierge/containers/ConciergeContainer.jsx